import { useTranslation } from 'react-i18next';

import { Typography } from '@speeki/global-ui-components';

import { getPath } from '@services/RouteService/paths';

import { LoginLink } from './LoginText.styled';

interface LoginTextProps {
    hideQuestion?: boolean;
}

export const LoginText = ({ hideQuestion }: LoginTextProps) => {
    const { t } = useTranslation();

    return (
        <Typography.TextBody_16_24>
            {!hideQuestion && `${t('ALREADY_HAVE_AN_ACCOUNT_TEXT')} `}
            <LoginLink to={getPath({ path: '/auth/login' })}>
                {t('LOGIN')}
            </LoginLink>
        </Typography.TextBody_16_24>
    );
};
